import React from "react";
import { PlayCircle } from "lucide-react";
import { useCopy } from "@/contexts/LanguageContext";
import { TOUR_STEPS, TOUR_ACCOUNTS } from "@/lib/tourSteps";
import { startTour } from "@/components/tour/TourOverlay";
import { useAuth } from "@/contexts/AuthContext";

const COPY = {
  en: { tag: "Presenter mode", h: "Guided demo tour", p: "Twelve screens in one story — an MSME borrower, the bank's Relationship Manager, and the State government. A caption card explains each screen; you sign in to each role when prompted. Screens auto-advance every 30 seconds — pause or skip at any time.", acts: "Three acts", start: "Start the tour", roles: { borrower: "MSME borrower", bank_rm: "Bank RM", government: "Government" }, screens: "screens" },
  hi: { tag: "प्रस्तुति मोड", h: "निर्देशित डेमो टूर", p: "एक कहानी में बारह स्क्रीन — MSME उधारकर्ता, बैंक का रिलेशनशिप मैनेजर और राज्य सरकार। हर स्क्रीन को एक कैप्शन कार्ड समझाता है; संकेत मिलने पर आप हर भूमिका से साइन इन करते हैं। हर स्क्रीन 30 सेकंड बाद अपने आप आगे बढ़ती है — कभी भी रोकें या आगे बढ़ें।", acts: "तीन भाग", start: "टूर शुरू करें", roles: { borrower: "MSME उधारकर्ता", bank_rm: "बैंक RM", government: "सरकार" }, screens: "स्क्रीन" },
};

export default function DemoTour() {
  const c = useCopy(COPY);
  const { user } = useAuth();
  const counts = TOUR_STEPS.reduce((a, s) => ({ ...a, [s.role]: (a[s.role] || 0) + 1 }), {});
  const begin = () => { startTour(); window.location.assign(user?.role === "borrower" ? "/dashboard" : `/login?email=${encodeURIComponent(TOUR_ACCOUNTS.borrower)}`); };
  return (
    <div className="brand-body max-w-4xl mx-auto px-6 lg:px-10 py-24" data-testid="demo-tour-page">
      <div className="text-[11px] uppercase tracking-[0.18em] text-[color:var(--bk-saffron)]">{c.tag}</div>
      <h1 className="mt-3 brand-heading text-4xl sm:text-5xl text-[color:var(--bk-navy)]">{c.h}</h1>
      <p className="mt-5 text-lg text-[color:var(--bk-navy)]/75 leading-relaxed max-w-2xl">{c.p}</p>
      <div className="mt-10 text-[11px] uppercase tracking-[0.18em] text-[color:var(--bk-navy)]/60">{c.acts}</div>
      <ol className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
        {Object.keys(TOUR_ACCOUNTS).map((r, i) => (
          <li key={r} className="p-5 rounded-2xl bg-white border border-[color:var(--bk-line)]" data-testid={`demo-act-${r}`}>
            <div className="brand-heading text-2xl text-[color:var(--bk-saffron)]">0{i + 1}</div>
            <div className="mt-2 brand-heading text-lg text-[color:var(--bk-navy)]">{c.roles[r]}</div>
            <div className="mt-1 text-xs text-[color:var(--bk-navy)]/60 font-mono">{TOUR_ACCOUNTS[r]}</div>
            <div className="mt-1 text-xs text-[color:var(--bk-navy)]/60">{counts[r]} {c.screens}</div>
          </li>
        ))}
      </ol>
      <button onClick={begin} data-testid="demo-tour-start" className="mt-10 btn-primary inline-flex"><PlayCircle className="w-4 h-4" /> {c.start}</button>
    </div>
  );
}
